export default {
  title: {
    id: 'product_page_express_replacement_modal_title',
    defaultMessage: 'Express Replacement',
  },
  section1Title: {
    id: 'product_page_express_replacement_modal_section1_title',
    defaultMessage: 'What’s Express Replacement?',
  },
  section1Text: {
    id: 'product_page_express_replacement_modal_section1_text',
    defaultMessage:
      'If you have any issues with the purchase, we’ll replace it with identical device. Then, send the original back once you receive your replacement so you’re never without a device.',
  },
  section2Title: {
    id: 'product_page_express_replacement_modal_section2_title',
    defaultMessage: 'How does it work?',
  },
  section2Item1Title: {
    id: 'product_page_express_replacement_modal_section2_item1_title',
    defaultMessage: 'Confirm your credit card',
  },
  section2Item1Text: {
    id: 'product_page_express_replacement_modal_section2_item1_text',
    defaultMessage:
      'You may see a $0 charge to your account. We’re just checking that your credit card is valid.',
  },
  section2Item2Title: {
    id: 'product_page_express_replacement_modal_section2_item2_title',
    defaultMessage: 'Get your replacement device within a few days',
  },
  section2Item2Text: {
    id: 'product_page_express_replacement_modal_section2_item2_text',
    defaultMessage: 'Free shipping.',
  },
  section2Item3Title: {
    id: 'product_page_express_replacement_modal_section2_item3_title',
    defaultMessage: 'GReturn the original ',
  },
  section2Item3Text: {
    id: 'product_page_express_replacement_modal_section2_item3_text',
    defaultMessage:
      'When the seller gets the original device, they’ll inspect it within 2 business days. ',
  },
}
